/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-16 00:00:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import {
  SI_CHECK_THEME_STATUS_REQUEST,
  SI_CHECK_THEME_STATUS_SUCCESS,
  SI_CHECK_THEME_STATUS_FAILURE,
  SI_THEME_INTEGRATION_SETUP_REQUEST,
  SI_THEME_INTEGRATION_SETUP_SUCCESS,
  SI_THEME_INTEGRATION_SETUP_FAILURE,
  SI_THEME_INTEGRATION_UPGRADE_REQUEST,
  SI_THEME_INTEGRATION_UPGRADE_SUCCESS,
  SI_THEME_INTEGRATION_UPGRADE_FAILURE,
  SIThemeIntegrationState,
  SIThemeIntegrationAction,
  SI_THEME_INTEGRATION_SETTINGS_REQUEST,
  SI_THEME_INTEGRATION_SETTINGS_SUCCESS,
  SI_THEME_INTEGRATION_SETTINGS_FAILURE,
  SI_THEME_INTEGRATION_UPDATE_FIELD,
  SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS
} from 'stores/flow-type/shopify-integration/theme-integration.type';

const initialState: SIThemeIntegrationState = {
  selectedTheme: {},
  selectedThemeId: '',
  checkingTheme: false,
  checkingThemeSuccess: false,
  templateInstance: {},
  currentTemplateId: '',
  isLiveTheme: false,
  isIsNewTemplate: false,

  // Theme setup
  integratingTheme: false,
  integratingThemeSuccess: false,
  createdTemplateInstance: {},

  // Theme upgrade
  upgradingTheme: false,
  upgradingThemeSuccess: false,
  upgradedTemplateInstance: {},

  widgetSettings: {},
  scssContent: '',
  translations: {}
};

const ThemeIntegrationReducers = (
  state: SIThemeIntegrationState = initialState,
  action: SIThemeIntegrationAction
) => {
  switch (action.type) {
    case SI_CHECK_THEME_STATUS_REQUEST:
      return { ...state, checkingTheme: true, checkingThemeSuccess: false };
    case SI_CHECK_THEME_STATUS_SUCCESS: {
      const { data = {} } = action.payload;
      return {
        ...state,
        checkingTheme: false,
        checkingThemeSuccess: true,
        error: undefined,
        templateInstance: data
      };
    }
    case SI_CHECK_THEME_STATUS_FAILURE:
      return {
        ...state,
        checkingTheme: false,
        checkingThemeSuccess: false,
        error: action.payload
      };

    case SI_THEME_INTEGRATION_SETUP_REQUEST:
      return {
        ...state,
        integratingTheme: true,
        integratingThemeSuccess: false,
        createdTemplateInstance: {}
      };
    case SI_THEME_INTEGRATION_SETUP_SUCCESS: {
      const { data = {} } = action.payload;
      return {
        ...state,
        integratingTheme: false,
        integratingThemeSuccess: true,
        error: undefined,
        createdTemplateInstance: data
      };
    }
    case SI_THEME_INTEGRATION_SETUP_FAILURE:
      return {
        ...state,
        integratingTheme: false,
        integratingThemeSuccess: false,
        createdTemplateInstance: {},
        error: action.payload
      };

    case SI_THEME_INTEGRATION_UPGRADE_REQUEST:
      return {
        ...state,
        upgradingTheme: true,
        upgradingThemeSuccess: false
      };
    case SI_THEME_INTEGRATION_UPGRADE_SUCCESS: {
      const { data = {} } = action.payload;
      return {
        ...state,
        upgradingTheme: false,
        upgradingThemeSuccess: true,
        upgradedTemplateInstance: data,
        error: undefined
      };
    }
    case SI_THEME_INTEGRATION_UPGRADE_FAILURE:
      return {
        ...state,
        upgradingTheme: false,
        upgradingThemeSuccess: false,
        error: action.payload
      };

    case SI_THEME_INTEGRATION_SETTINGS_REQUEST:
      return { ...state, checkingTheme: true, checkingThemeSuccess: false };
    case SI_THEME_INTEGRATION_SETTINGS_SUCCESS: {
      const { data = {} } = action.payload;
      const firstLocaleKey = Object.keys(data?.translations)[0];
      return {
        ...state,
        checkingTheme: false,
        checkingThemeSuccess: true,
        error: undefined,
        widgetSettings: data?.settings || {},
        scssContent: data?.scssContent || '',
        translations:
          _.get(data, 'translations.en') || _.get(data, `translations.${firstLocaleKey}`) || {}
      };
    }
    case SI_THEME_INTEGRATION_SETTINGS_FAILURE:
      return {
        ...state,
        checkingTheme: false,
        checkingThemeSuccess: false,
        error: action.payload
      };

    case SI_THEME_INTEGRATION_UPDATE_FIELD: {
      const { fieldName, data } = action?.payload;
      return {
        ...state,
        [fieldName]: data
      };
    }

    case SI_THEME_INTEGRATION_UPDATE_MULTI_FIELDS: {
      const { data } = action?.payload;
      return {
        ...state,
        ...data
      };
    }
    default:
      return state;
  }
};
export default ThemeIntegrationReducers;
